<template>
  <div class="c-info">
    <h2>
      Wyjątkowa oferta na wszystkie modele Audi z rocznika 2018.
    </h2>
    <p>Samochody dostępne w specjalnych cenach z korzyścią do 23%, rekompensującą zmiany podatkowe w leasingu*.</p>
    <p>Oferta łączy się z promocyjnym finansowaniem Audi Classic Leasing 101%, 103%, 105%.</p>
    <p>Alternatywnie do cen specjalnych możesz skorzystać z innowacyjnego finansowania Audi Perfect Lease.</p>
    <p>Prezentowane poniżej ceny specjalne brutto uwzględniają rekomendowane korzyści dla modeli z rocznika 2018.</p>
    <p><strong>Znajdź swoje Audi lub wypełnij i wyślij formularz kontaktowy. Zadzwonimy do Ciebie, aby przygotować ofertę na wybrany samochód.</strong></p>
  </div>
</template>
<script>
export default {
  name: 'Info'
}
</script>
<style lang="scss">
  .c-info{
    margin: 0 auto;
    max-width: 1177.6px;
    width: 92%;
    padding-bottom: 3rem;
    h2{
      margin-top:2rem;
      font-size: 1.9rem;
      margin-bottom: 3rem;
      @media(max-width: 960px){
        margin-top:1.5rem;
        font-size: 1.2rem;
        margin-bottom: 2rem;
      }
    }
    ul{
      list-style-type: none;
      padding: 0px;
      li{
        font-size: 1.4rem;
        line-height: 2.4rem;
        @media(max-width: 960px){
          font-size: .9rem;
          line-height: 2rem;
        }
      }
    }
    p{
      font-size: 1.4rem;
      line-height: 1.8rem;
      @media(max-width: 960px){
        font-size: .9rem;
        line-height: 2rem;
      }
    }
  }
</style>
